import React from 'react';

import cn from 'classnames';

export const Label = React.forwardRef<
  HTMLLabelElement,
  React.LabelHTMLAttributes<HTMLLabelElement>
>(({ className, ...labelProps }, ref) => {
  return (
    // eslint-disable-next-line jsx-a11y/label-has-associated-control
    <label
      ref={ref}
      className={cn(
        'text-primary-10 inline-block font-med align-middle',
        className,
      )}
      {...labelProps}
    />
  );
});

Label.displayName = 'Label';
